import { responseStatus, useHandleRequest } from "../service/api-services";
import { getDefaultQuery } from "../utils/query-client";

export const defectTypesQueries = {
    EDIT: "DEFECTTYPE_EDIT",
    CREATE: "DEFECTTYPE_CREATE",
    DELETE: "DEFECTTYPE_DELETE",
    GET_ALL: "DEFECTTYPE_GET_ALL",
    GET_ALL_OPTIONS: "DEFECTTYPE_GET_ALL_OPTIONS",
    GET_BY_ID: "DEFECTTYPE_GET_BY_ID",
}


export function useDefectTypeService() {

    const handleRequest = useHandleRequest();

    async function createDefectType({ payload, onSuccess }) {
        const { status, data } = await handleRequest.handleRequest(`/defect-types/${payload.id}`, 'PUT', payload);
        if (status === responseStatus.SUCCESS) {
            if (onSuccess) {
                onSuccess(data);
            }
        }
    }

    async function editDefectType({ payload, onSuccess }) {
        const { status, data } = await handleRequest.handleRequest(`/defect-types/${payload.id}`, 'PUT', payload);
        if (status === responseStatus.SUCCESS) {
            if (onSuccess) {
                onSuccess(data);
            }
        }
    }

    async function deleteDefectType({ id, onSuccess }) {
        const { status, data } = await handleRequest.handleRequest(`/defect-types/${id}`, 'DELETE');
        if (status === responseStatus.SUCCESS) {
            if (onSuccess) {
                onSuccess(data);
            }
        }
    }

    async function getAllDefectType({ search, page }) {
        const filters = [{ search }];
        let query = getDefaultQuery({ page, filters });
        const { status, data } = await handleRequest.handleRequest(`/defect-types/${query}`, 'GET');
        if (status === responseStatus.SUCCESS) {
            return data;
        }
    }

    async function getAllDefectTypeOptions({ search, page }) {
        const filters = [{ search }];
        let query = getDefaultQuery({ page, filters });
        const { status, data } = await handleRequest.handleRequest(`/defect-types/${query}`, 'GET');
        if (status === responseStatus.SUCCESS) {
            return data.rows.map(data=>({key: data.id, value: data.name}));
        }
    }

    async function getDefectTypeById({ id }) {
        if (id) {
            const { status, data } = await handleRequest.handleRequest(`/defect-types/${id}`, 'GET');
            if (status === responseStatus.SUCCESS) {
                return data;
            }
        }
    }

    return {
        createDefectType,
        editDefectType,
        deleteDefectType,
        getAllDefectType,
        getDefectTypeById,
        getAllDefectTypeOptions
    }
}
